import { Checkbox } from '@/components/ui/checkbox';
import { Label } from '@/components/ui/label';
import { Button } from '@/components/ui/button';
import {
  EXPORT_COLUMNS,
  DEFAULT_COLUMNS,
  type ExportColumn,
} from '@/lib/exportApi';

interface ColumnSelectorProps {
  selectedColumns: ExportColumn[];
  onChange: (columns: ExportColumn[]) => void;
}

export function ColumnSelector({
  selectedColumns,
  onChange,
}: ColumnSelectorProps) {
  const handleToggle = (column: ExportColumn, checked: boolean) => {
    if (checked) {
      onChange([...selectedColumns, column]);
    } else {
      onChange(selectedColumns.filter((c) => c !== column));
    }
  };

  const handleSelectAll = () => {
    onChange(EXPORT_COLUMNS.map((c) => c.value));
  };

  const handleSelectDefault = () => {
    onChange([...DEFAULT_COLUMNS]);
  };

  const handleClearAll = () => {
    onChange([]);
  };

  return (
    <div className="space-y-3">
      <div className="flex items-center justify-between">
        <span className="text-sm font-medium">Columns to Export</span>
        <div className="flex gap-1">
          <Button
            variant="ghost"
            size="sm"
            className="h-7 text-xs"
            onClick={handleSelectAll}
          >
            All
          </Button>
          <Button
            variant="ghost"
            size="sm"
            className="h-7 text-xs"
            onClick={handleSelectDefault}
          >
            Default
          </Button>
          <Button
            variant="ghost"
            size="sm"
            className="h-7 text-xs"
            onClick={handleClearAll}
          >
            Clear
          </Button>
        </div>
      </div>

      <div className="grid grid-cols-1 gap-2 rounded-lg border p-3 sm:grid-cols-2">
        {EXPORT_COLUMNS.map((column) => (
          <div key={column.value} className="flex items-center space-x-2">
            <Checkbox
              id={`col-${column.value}`}
              checked={selectedColumns.includes(column.value)}
              onCheckedChange={(checked) =>
                handleToggle(column.value, checked === true)
              }
            />
            <Label
              htmlFor={`col-${column.value}`}
              className="text-sm font-normal cursor-pointer"
            >
              {column.label}
            </Label>
          </div>
        ))}
      </div>

      <p className="text-xs text-muted-foreground">
        {selectedColumns.length} of {EXPORT_COLUMNS.length} columns selected
      </p>
    </div>
  );
}
